import gql from 'graphql-tag';

export const MODIFY_STOCK_DELIVERY_ITEM = gql`
	mutation modifyStockDeliveryItemMutation ($input: ModifyStockDeliveryItemInput!) {
		modifyStockDeliveryItem (input: $input) {
			stockdeliveryitem {
				id
				quantity
			}
		}
	}
`;

export const MODIFY_STOCK_DELIVERY_ITEM_RECEIVEDAT = gql`
	mutation modifyStockDeliveryItemsReceivedAt ($ids: [ID!]!) {
		modifyStockDeliveryItemsReceivedAt (ids: $ids) {
			id
			receivedAt
			deliveredAt
			destinationWarehouseProduct {
				id
				quantity
			}
			stockDelivery {
				id
				status
			}
		}
	}
`;

export const MARK_STOCK_DELIVERY_ITEMS_DELIVERED = gql`
	mutation markStockDeliveryItemsDeliveredAt ($ids: [ID!]!, $delivered: Boolean!) {
		markStockDeliveryItemsDeliveredAt (ids: $ids, delivered: $delivered) {
			id
			deliveredAt
			receivedAt
			stockDelivery {
				id
				status
			}
		}
	}
`;

export const RECEIVE_STOCK_DELIVERY_ITEMS_WITH_EXPIRY = gql`
	mutation receiveStockDeliveryItemsWithExpiry ($input: [ReceiveStockDeliveryItemWithExpiryInputType!]!) {
		receiveStockDeliveryItemsWithExpiry (input: $input) {
			id
			receivedAt
			deliveredAt
			expiryCaptureRequired
			expiryCapturedAt
		}
	}
`;

export const UNRECEIVE_STOCK_DELIVERY_ITEMS = gql`
	mutation unreceiveStockDeliveryItems ($ids: [ID!]!, $mode: String) {
		unreceiveStockDeliveryItems (ids: $ids, mode: $mode) {
			id
			receivedAt
			deliveredAt
			expiryCapturedAt
		}
	}
`;
